<template>
    <div class="insurance-variants-section">
        <ul class="insurance-variants-section__list">
            <li class="insurance-variants-section__item" 
                v-for="(card, idx) in cards"
                :key="idx">
                <InsuranceTariffCard 
                    :tariff="card.tariff"
                    :title="card.title"
                    :subtitle="card.subtitle"
                    :subtitlePrice="card.subtitlePrice"
                    :mark="card?.mark"
                    :old-price="card?.oldPrice"
                    :price="card.price"
                    :list-items="card.listItems"
                    @tariff-chosen="(tariff) => $emit('tariff-chosen', tariff)"
                    />
            </li>
        </ul>
        <BaseLink class="insurance-variants-section__cancel-subscription-link"
            id="cancel-button"
            tag="span"
            text="Отменить подписку можно здесь"
            underlined
            muted
            @click.native.prevent="$emit('cancel-subscription')"
            />
        <p class="insurance-variants-section__additional-info">
            Раздел страницы сайта страховой компании АО «Зетта Страхование». При возникновении технических проблем при оформлении программы обратитесь по телефону 8 800 700 77 07
        </p>
    </div>
</template>

<script>
import InsuranceTariffCard from '@/components/ui/InsuranceTariffCard';
import BaseLink from '@/components/ui/BaseLink';
import { INSURANCE_CARDS } from '@/consts';

export default {
    name: 'TheInsuranceVariants',
    components: {
        InsuranceTariffCard,
        BaseLink
    },
    computed: {
        cards() {
            return INSURANCE_CARDS
        }
    }
}
</script>

<style scoped lang="scss">
.insurance-variants-section {
    &__list {
        display: flex;
        justify-content: space-between;

        @media #{$screen-big} {
            flex-direction: column;
        }  
    }

    &__item {
        @include flex-width-three-in-row(24px);

        @media #{$screen-big} {
            @include resetting-vertical-indentation-of-first;

            width: 100%;

            margin-top: rem($gap-normal);
        }  
    }

    &__cancel-subscription-link {
        margin-top: rem($gap-big);
    }

    &__additional-info {
        @include text-normal($font-weight-regular, $line-height-normal);

        margin-top: rem($gap-normal);

        color: $color-text-muted;

        @media #{$screen-small} {
            font-size: rem($font-size-small);
        }  
    }
    
}
</style>